const screenLockMessages = {
  'screenLock.messages.displayKeyboard':
    '["入力をする際は縦にしてご利用ください"]',
  'screenLock.messages.notSupported':
    '["サポートされていない端末環境です", "ご不明点は管理者へお問い合わせください"]',
  'screenLock.messages.notCompatible':
    '["画面の表示領域が十分ではないため表示領域を拡大するか、", "表示内容をズームアウトしてご利用ください"]',
  'screenLock.messages.notAvailable':
    '["端末を横にするとデータが表示できません", "縦にしてご利用ください"]',
};

export default screenLockMessages;
